export const articleContent: Record<string, string> = {
  "top-star-secret-date": `<p>据知情人士透露，某顶流男星于上周五深夜被拍到与一名神秘女子进入某五星级酒店。据蹲守狗仔描述，该男星当晚10点左右抵达酒店地下车库，一名身穿黑色连衣裙的长发女子已在电梯口等候。二人一同进入电梯后前往高层套房。</p>
<p>更令人震惊的是，<strong>二人在房间内共处长达8小时</strong>，期间有酒店工作人员曾多次送餐进入房间。直到次日清晨6时许，该女子才独自离开酒店大堂，而男星则在一小时后从地下车库驾车离开。</p>
<p>据圈内人士爆料，该神秘女子疑似某知名经纪公司的新签约艺人，二人此前曾在多个商业活动中有过同框。目前双方团队均未对此事做出回应。</p>
<p>这已经是该男星今年第三次被曝光深夜约会，此前两次均被其工作室以"工作关系"为由否认。但此次有图有真相，网友纷纷表示"这次实锤了，粉丝也没法洗了"。</p>
<p>相关话题迅速登上热搜榜首，#顶流深夜密会# 话题阅读量在短短三小时内突破5亿。不少网友开始深挖该神秘女子的身份背景，目前已有多条线索指向某98年出生的新晋小花。</p>`,

  "influencer-tax-evasion": `<p>据国家税务总局消息，某拥有超过<strong>3000万粉丝</strong>的头部女网红因涉嫌偷逃个人所得税被立案调查。经初步核实，该网红在2023年至2025年期间，通过拆分合同、虚假申报等方式隐瞒直播打赏及广告收入，共计少缴税款约800万元。</p>
<p>税务机关已依法对其作出<strong>追缴税款、加收滞纳金并处罚款合计超过1200万元</strong>的行政处理决定。目前该网红的全平台社交账号均已被暂时封禁处理。</p>
<p>业内人士分析，该网红主要以直播带货和品牌代言为主要收入来源，年收入预估在5000万以上。此次被查后，与其合作的多个品牌已紧急下架相关宣传物料并宣布解约。</p>
<p>此事件引发全网热议，有网友表示"赚那么多还逃税，活该被查"，也有人感叹"又一个倒下的网红，流量来得快去得也快"。</p>
<p>据悉，近年来税务部门持续加强对网络主播等高收入群体的税收监管力度，已有数十位知名网红因偷逃税被查处。</p>`,

  "variety-show-conflict": `<p>据现场观众爆料，在某热门音乐选秀综艺的最新一期录制中，两位导师因一名选手的晋级问题产生了严重分歧。争执从最初的理性讨论迅速升级为<strong>激烈争吵</strong>，场面一度失控。</p>
<p>目击者描述，其中一位导师直接拍桌而起，指责对方"完全不懂音乐"，而另一方则回击称"你这是对选手的不负责任"。现场气氛紧张到极点，其他导师和主持人均试图调解但未能平息争端。</p>
<p>最终节目组导演不得不紧急叫停录制，将两位导师分别请到不同休息室进行沟通。录制中断长达近两个小时才得以恢复，但据称后续录制中两位导师全程零交流。</p>
<p>该消息一出立即引爆网络，#综艺导师互怼# 话题迅速登顶热搜。网友们分成两派激烈讨论，一派认为冲突是剧本安排为博眼球，另一派则认为两位导师的争执太过真实不像是演的。</p>
<p>截至目前，节目组官方尚未对此事发表任何声明，但预告该期节目将按原定档期播出，并表示"正片内容会更加精彩"。</p>`,

  "businessman-affair": `<p>近日，一则关于某知名科技公司创始人的出轨爆料在社交平台疯传。据爆料人提供的照片显示，该企业家与一名女性在过去半年内<strong>多次同游海外</strong>，包括马尔代夫、巴黎和东京等地。</p>
<p>更令人震惊的是，该女性被指是该企业家旗下某子公司的<strong>高级副总裁</strong>，二人存在直接上下级关系。据悉，该女高管年约35岁，已在公司任职超过5年，此前曾多次以高管身份陪同创始人出席各类公开活动。</p>
<p>该企业家与结发妻子结婚超过20年，育有三个子女，其妻子在社交媒体上一直以"幸福家庭"人设示人。此爆料一出，网友纷纷涌入其妻子社交账号留言，目前其妻子已关闭评论功能。</p>
<p>企业公关部门暂未对此事做出任何回应，但据内部人士透露，公司董事会已就该事件召开紧急会议，讨论此事可能对公司股价和品牌形象造成的影响。</p>`,

  "actor-cheating-exposed": `<p>深夜，某当红男星的前女友在社交平台发布长文，控诉其在两人交往期间<strong>同时与至少三名女性保持暧昧关系</strong>。该前女友在文中详细描述了发现男友出轨的过程，并附上了多张聊天记录截图作为证据。</p>
<p>据长文描述，两人于2025年初开始交往，交往期间男方以"工作忙"为由频繁失联。女方在一次偶然机会下查看了男方的备用手机，发现了<strong>大量与其他女性的暧昧聊天记录</strong>，时间跨度覆盖了整个交往期。</p>
<p>聊天记录显示，男方同时与一名网红主播、一名选秀选手以及一名圈外富家女保持亲密关系，且对每位女性都声称自己是"单身状态"。</p>
<p>该长文发布后迅速引爆网络，不到一小时转发量突破百万。该男星的社交媒体账号评论区已被网友"爆破"，大量粉丝表示"塌房"并删除相关应援内容。多个代言品牌已紧急撤下与该男星相关的宣传海报。</p>
<p>截至目前，该男星方面尚未做出任何回应，但其工作室的官方账号已设置为"仅关注者可评论"。</p>`,

  "talent-show-fake-degree": `<p>去年在某大型选秀节目中一举夺冠的选手，近日被网友扒出存在<strong>学历造假</strong>问题。该选手在参赛期间及赛后多次公开表示自己毕业于某知名音乐学院本科，但经过网友深挖核实，其最高学历实际上仅为初中毕业。</p>
<p>据知情人士透露，该选手确实曾在该音乐学院参加过短期培训班，但并未取得任何正式的学历或学位证书。其对外宣称的"学士学位"纯属夸大其词。</p>
<p>此事曝光后，该选手的粉丝群体陷入巨大争议。部分粉丝表示"才艺和学历无关"，但也有大量网友认为<strong>"造假就是人品问题"</strong>，呼吁业内对其进行抵制。</p>
<p>该选手此前签约的经纪公司发表声明称"正在核实相关情况"，并强调"选手的艺术才华和舞台表现力才是最重要的"。但据行业内部消息，已有多个原定合作项目被暂停。</p>`,

  "celebrity-divorce": `<p>被誉为娱乐圈模范夫妻的一对明星夫妇近日被曝出<strong>正在办理离婚手续</strong>。据知情人士透露，二人已于三个月前开始分居，目前正在进行财产分割谈判。</p>
<p>这对夫妇结婚八年，育有一子一女，一直以来在公众面前都展现出恩爱和谐的形象。然而据接近二人的朋友透露，双方感情早在两年前就已出现裂痕，只是一直"为了孩子和事业"勉力维持。</p>
<p>据悉，二人名下共同财产涉及多套豪宅、数家公司股权以及大量投资理财资产，<strong>总价值预估超过5亿元</strong>。财产分割将是离婚过程中的最大难点。</p>
<p>消息传出后，相关话题迅速登上热搜榜首。许多网友表示惋惜，评论称"再也不相信娱乐圈的爱情了"，也有理性声音认为"感情的事外人没有资格评判"。</p>
<p>目前双方经纪公司均未对此做出官方回应。</p>`,

  "2026-half-year-review": `<p>2026年已经过半，这半年来娱乐圈和网红圈的塌房事件可谓层出不穷。今天我们就来做一个<strong>完整回顾</strong>，盘点上半年那些最令人震惊的十大塌房事件。</p>
<h4>第一名：顶流男星深夜密会事件</h4>
<p>某顶流男星被拍到与神秘女子在酒店共度8小时，全网实锤，粉丝集体心碎。</p>
<h4>第二名：头部女网红偷税千万被封</h4>
<p>3000万粉丝网红因偷逃税款被罚款超1200万，全平台封禁，品牌纷纷解约。</p>
<h4>第三名：知名企业家婚内出轨女高管</h4>
<p>身价数十亿的科技大佬被曝与子公司高管有染，家庭形象彻底崩塌。</p>
<p>此外，还有综艺导师互怼、男星劈腿三人、选秀冠军学历造假、金童玉女离婚等一系列重磅事件。每一件都曾引爆热搜，每一个都让吃瓜群众大呼过瘾。</p>
<p>纵观这半年，塌房事件呈现出<strong>高密度、高话题度</strong>的特点，几乎每个月都有至少一起重量级爆料。吃瓜群众纷纷表示"今年的瓜特别大、特别甜"。</p>`,

  "streamer-quit-threat": `<p>昨晚，某直播平台的头牌女主播在例行直播中突然情绪失控，泪洒当场后宣布<strong>永久退出直播圈</strong>。这一突如其来的消息让数百万在线观众震惊不已。</p>
<p>据事后知情人士爆料，该主播的退网决定并非一时冲动。近半年来，她一直遭受来自同行的<strong>恶意竞争和人身威胁</strong>。有不明身份人员曾多次在其住所附近徘徊，其家人也收到了匿名的恐吓信息。</p>
<p>该主播在直播中哽咽表示："我真的撑不下去了，每天活在恐惧中。钱再多也换不回安全感。"随后她在镜头前深深鞠躬感谢粉丝多年的支持，随即关闭了直播。</p>
<p>消息传出后，大量粉丝涌入其社交账号留言表达不舍与愤怒。平台方面发表声明称将配合警方调查相关威胁事件，但该主播的去意似乎已决。</p>
<p>该事件也引发了关于直播行业恶性竞争问题的广泛讨论。多位知名主播发声表示曾遭受类似经历，呼吁行业建立更完善的从业者保护机制。</p>`,

  "director-harassment-allegations": `<p>今日，<strong>五位女演员</strong>联合发布了一封致业界的公开信，实名指控某知名导演在合作期间多次实施性骚扰行为。该导演曾执导过多部票房过亿的电影，在业内具有相当影响力。</p>
<p>据公开信内容，五位女演员分别在不同年份与该导演有过合作。她们描述的经历包括：<strong>不当身体接触、深夜以"讲戏"为由要求单独见面、发送露骨信息</strong>等。其中最早的一起事件可追溯到八年前。</p>
<p>公开信中写道："我们选择站出来，不是为了博取同情，而是希望这个行业不再有人经历我们所经历的伤害。沉默不是解决办法。"</p>
<p>该公开信发布后迅速引发全网关注。多个行业协会发表声明表示强烈谴责此类行为，并将配合有关部门进行调查。涉事导演的所有社交媒体账号已设为私密，其正在进行的电影项目据称已被投资方叫停。</p>
<p>警方已确认收到相关举报材料，并已正式立案展开调查。</p>`,

  "couple-influencer-breakup": `<p>坐拥<strong>500万粉丝</strong>的知名情侣网红账号近日突然停止更新。随后，男方在其个人账号发表长文，指控女方在恋爱期间出轨，并附上了多张聊天记录截图。</p>
<p>据男方描述，他发现女方与至少两名男性存在超出正常社交范围的互动。聊天记录显示，女方曾多次在深夜与其中一名男性进行长时间语音通话，并使用了"想你""睡不着"等亲密词汇。</p>
<p>女方随后也发文回击，否认出轨指控，并反过来指责男方<strong>控制欲过强、限制其社交自由</strong>，称此次互撕是男方蓄谋已久的"人设营销"行为。</p>
<p>两人的互撕大战持续发酵，双方粉丝阵营在评论区展开激烈对战。曾经以甜蜜互动吸引粉丝的情侣网红如今反目成仇，让许多忠实粉丝大呼"再也不敢相信网红情侣了"。</p>
<p>目前双方均已删除合拍视频，该情侣账号或面临解体和粉丝大量流失的结局。</p>`,

  "singer-downfall-timeline": `<p>三个月前，他还是站在舞台上光芒万丈的顶流歌手；三个月后的今天，他的代言全部解约、演唱会被取消、社交媒体被禁言。这期间到底发生了什么？</p>
<h4>4月初：疑似私生活混乱传闻首次流出</h4>
<p>有匿名网友在论坛发帖暗示该歌手私生活混乱，但当时并未引起广泛关注。</p>
<h4>4月中旬：前女友发文暗示</h4>
<p>该歌手的前任女友在社交平台发布意味深长的文字，被网友解读为暗指其人品问题。</p>
<h4>5月：多位女性联合爆料</h4>
<p>三位自称与该歌手有过感情纠葛的女性先后发声，指控其<strong>多次劈腿、情感欺骗</strong>。</p>
<h4>6月：品牌解约潮</h4>
<p>事件持续发酵，该歌手代言的七个品牌陆续宣布终止合作，预估损失超2亿元。</p>
<h4>7月：账号禁言，演唱会取消</h4>
<p>其全平台社交账号被禁言，原定暑期举办的五场万人演唱会全部取消。</p>
<p>业内人士分析，此次塌房的根本原因在于<strong>人设与真实形象的严重割裂</strong>，以及危机公关的完全失败。</p>`,
};